import React from 'react';
import { Input } from '@this/shared/ui/inputs/input';
import { colors } from '@this/shared/ui/theme/tokens/primitive-tokens/colors';
import { onlineApplicationStyles } from './styles';
import type { ValidationErrors } from './types';
import type { ValidationFieldName } from '../shared/validation';

interface SubmitterFieldsProps {
  submitterCompanyName: string;
  submitterDepartment: string;
  submitterName: string;
  submitterEmail: string;
  errors: ValidationErrors;
  touched: Record<string, boolean>;
  onSubmitterCompanyNameChange: (value: string) => void;
  onSubmitterDepartmentChange: (value: string) => void;
  onSubmitterNameChange: (value: string) => void;
  onSubmitterEmailChange: (value: string) => void;
  onBlur: (field: ValidationFieldName) => void;
}

export const SubmitterFields: React.FC<SubmitterFieldsProps> = ({
  submitterCompanyName,
  submitterDepartment,
  submitterName,
  submitterEmail,
  errors,
  touched,
  onSubmitterCompanyNameChange,
  onSubmitterDepartmentChange,
  onSubmitterNameChange,
  onSubmitterEmailChange,
  onBlur
}) => {
  return (
    <>
      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          会社名 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={submitterCompanyName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSubmitterCompanyNameChange(e.target.value)}
          onBlur={() => onBlur('submitterCompanyName')}
          placeholder="会社名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.submitterCompanyName && errors.submitterCompanyName)}
        />
        {touched.submitterCompanyName && errors.submitterCompanyName && (
          <div style={onlineApplicationStyles.formError.text}>{errors.submitterCompanyName}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          所属部署名 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={submitterDepartment}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSubmitterDepartmentChange(e.target.value)}
          onBlur={() => onBlur('submitterDepartment')}
          placeholder="所属部署名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.submitterDepartment && errors.submitterDepartment)}
        />
        {touched.submitterDepartment && errors.submitterDepartment && (
          <div style={onlineApplicationStyles.formError.text}>{errors.submitterDepartment}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          氏名 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={submitterName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSubmitterNameChange(e.target.value)}
          onBlur={() => onBlur('submitterName')}
          placeholder="申込者名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.submitterName && errors.submitterName)}
        />
        {touched.submitterName && errors.submitterName && (
          <div style={onlineApplicationStyles.formError.text}>{errors.submitterName}</div>
        )}
      </div>

      <div style={onlineApplicationStyles.form.input.wrapper}>
        <span style={onlineApplicationStyles.label.base}>
          メールアドレス <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          type="email"
          value={submitterEmail}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSubmitterEmailChange(e.target.value)}
          onBlur={() => onBlur('submitterEmail')}
          placeholder="メールアドレスを入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.submitterEmail && errors.submitterEmail)}
        />
        {touched.submitterEmail && errors.submitterEmail && (
          <div style={onlineApplicationStyles.formError.text}>{errors.submitterEmail}</div>
        )}
      </div>
    </>
  );
};
